import React, { Fragment } from 'react'

import { ProcessEntity, ProcessStatus } from '../Types/entities'
import { TableColumn } from '../../../components/_EOS/GenericTable'
import { Chip, Tooltip, Typography } from '@mui/material'
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import ScheduleIcon from '@mui/icons-material/Schedule'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { utcToLocal } from '../../../utils/dateHelper'

const formatDate = (value: unknown) =>
  value ? utcToLocal(value.toString(), 'dd/MM/yyyy HH:mm:ss') : ''

export const getColumnsConfig = (): TableColumn<ProcessEntity>[] => [
  { key: 'processId', title: 'Nro.' },
  { key: 'typeProcessName', title: 'Tipo' },
  {
    key: 'fileName',
    title: 'Nombre',
    render: (value) => formatFileName(value as string)
  },
  { key: 'userName', title: 'Usuario' },
  {
    key: 'statusId',
    title: 'Estado',
    render: (value) => setStatus(value)
  },
  {
    key: 'createDate',
    title: 'Fecha Creación',
    render: (value) => formatDate(value)
  },
  {
    key: 'startDate',
    title: 'Fecha Inicio',
    render: (value) => formatDate(value)
  },
  {
    key: 'endDate',
    title: 'Fecha Fin',
    render: (value) => formatDate(value)
  }
]

const setStatus = (id: number | unknown) => {
  let label = ''
  let icon = null
  let color = ''

  switch (id) {
    case ProcessStatus.Created:
      label = 'Creado'
      icon = <PlaylistAddCheckIcon />
      color = '#2196f3'
      break
    case ProcessStatus.InProcess:
      label = 'En Proceso'
      icon = <ScheduleIcon />
      color = '#ffea00'
      break
    case ProcessStatus.Finalized:
      label = 'Finalizado'
      icon = <CheckCircleOutlineIcon />
      color = '#4caf50'
      break
    default:
      label = 'Con Errores'
      icon = <ErrorOutlineIcon />
      color = '#f48fb1'
      break
  }

  return (
    <Fragment>
      <Chip
        icon={icon}
        label={label}
        size='small'
        sx={{
          backgroundColor: color,
          '& .MuiChip-label': {
            fontSize: '0.8rem',
            px: 0.5
          },
          '& .MuiChip-icon': {
            fontSize: '0.9rem',
            mr: 0.1
          }
        }}
      />
    </Fragment>
  )
}

export const downloadBase64File = (
  base64: string,
  fileName: string,
  mimeType: string
) => {
  // Decodifica la cadena base64
  const byteCharacters = atob(base64)
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0))
  const byteArray = new Uint8Array(byteNumbers)

  // Crea un Blob con el tipo MIME correcto
  const blob = new Blob([byteArray], { type: mimeType })

  // Crea un enlace y lo dispara para descargar
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()

  // Limpieza
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const formatFileName = (fileName: string) => {
  return (
    <Tooltip title={fileName}>
      <Typography
        variant='body2'
        sx={{
          // El nombre envuelve hasta 2 líneas cuando la columna se angosta y,
          // si aún no entra, corta con elipsis (...).
          maxWidth: 192,
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {fileName}
      </Typography>
    </Tooltip>
  )
}

export const downloadBase64FileDialog = (
  base64: string,
  fileName: string,
  mimeType: string
) => {
  // Decodifica la cadena base64
  const byteCharacters = atob(base64)
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0))
  const byteArray = new Uint8Array(byteNumbers)

  // Crea un Blob con el tipo MIME correcto
  const blob = new Blob([byteArray], { type: mimeType })

  // Crea un enlace y lo dispara para descargar
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()

  // Limpieza
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
